export default __webpack_public_path__ + "static/healthcare-28bfc37c726f1b0d1c274bd012d0e1ac.png";